import * as React from 'react';
import { IStyleConfig, mergeStyles } from '@cian/utils';
import { Arrow } from '../Icons';
import * as styles from './CollapseButton.css';

export interface ICollapseButtonProps {
  isCollapsed: boolean;
  buttonStyles?: IStyleConfig;
  onClick(): void;
}

export function CollapseButton({ isCollapsed, buttonStyles, onClick }: ICollapseButtonProps) {
  return (
    <span {...mergeStyles(
      styles['collapse_button'],
      isCollapsed && styles['collapse_button--collapsed'],
      buttonStyles,
    )}
      onClick={onClick}
    >
      {isCollapsed ? 'Развернуть' : 'Свернуть'}
      <span className={styles['arrow']}>
        <Arrow />
      </span>
    </span>
  );
}
